import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import { LoadingCircle } from 'hosman-material';

import { updateYousignStatus } from '../../../../../../../../reducers/SellerApp/mandatesSlice';

const SignatureIframe = () => {
  const { mandate, isGenerating, yousignStatus } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin === 'https://yousign.app' && e.data.type === 'yousign') {
        switch (e.data.event) {
          case 'started':
          case 'success':            
            dispatch(updateYousignStatus(e.data.event));
            break;
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div data-testid='SignatureIframe'>
      {isGenerating &&
        <div className='flex justify-center' data-testid='LoadingCircle'>
          <LoadingCircle />
        </div>
      }

      {(!isGenerating && yousignStatus !== 'success') &&
        <iframe src={mandate.yousign_url} className='w-full h-[800px]' referrerPolicy='strict-origin-when-cross-origin' data-testid='signtureIframe'></iframe>
      }
    </div>
  );
}

export default SignatureIframe;
